import React, { useContext, useEffect, useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import BatchErrorsGrid from '../../BatchErrorsGrid';
import BatchFormContext from '../BatchFormContext';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import scheduleTask from '@afosto/utils-react/tasks/scheduleTask';
import { batches as batchesApi } from '@afosto/content/api/Batches';
import translations from './translations';

const BatchValidation = () => {
  const intl = useIntl();
  const { batch, isValid, setIsValid } = useContext(BatchFormContext);
  const [isValidating, setIsValidating] = useState(true);
  const [showErrors, setShowErrors] = useState(false);

  useEffect(() => {
    const validateBatch = async () => {
      setShowErrors(false);
      setIsValidating(true);

      try {
        const validationResponse = await batchesApi.validateBatch(batch?.id);
        const taskId = validationResponse.headers?.['x-task-id'];

        await scheduleTask(taskId);

        setIsValid(true);
      } catch (err) {
        const { task } = err ?? {};

        if (!task?.is_success) {
          setShowErrors(true);
        }

        if (err?.is_success === false && err?.percentage === 100) {
          setShowErrors(true);
        }

        if (err?.response?.status === 400) {
          setShowErrors(true);
        }

        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    if (batch) {
      validateBatch();
    }
  }, [batch, setIsValid]);

  return (
    <Box width="100%">
      {isValidating && (
        <>
          <Typography variant="body2">
            {intl.formatMessage(translations.validatingMessage)}
          </Typography>
          <LoadingWrapper isLoading={isValidating} style={{ minHeight: 150, minWidth: 150 }} />
        </>
      )}
      {!isValidating && !showErrors && isValid && (
        <Typography variant="body2">
          {intl.formatMessage(translations.validationSucceeded)}
        </Typography>
      )}
      {!isValidating && showErrors && (
        <Box mt={2}>
          <Typography variant="body2" color="error">
            {intl.formatMessage(translations.validationFailed)}
          </Typography>
          <BatchErrorsGrid batchId={batch?.id} />
        </Box>
      )}
    </Box>
  );
};

export default BatchValidation;
